import React from 'react';
import {ResponsiveContainer, AreaChart, XAxis, YAxis, Tooltip, Area, CartesianGrid} from 'recharts';
import CustomTooltip from '../CustomTooltip'
import { Select } from 'antd';
import moment from 'moment'
const { Option } = Select

class CompareTool extends React.Component {

  state = {
    compare: 'Compare',
    option_first_year: 'Year',
    option_first: 'Selection',
    option_second_year: 'Year',
    option_second: 'Selection',
    selectedCategory: 'all',
    selectedCluster: 'all'
  }

  getGrades = (field) => {
    let yearSelection = field === 'first' ? this.state.option_first_year : this.state.option_second_year
    if (this.props.classes && this.props.allYears && yearSelection !== 'Year') {
      let {from, to, text} = this.props.allYears.filter( year => year.text === yearSelection)[0]
      let grades = []
      let classes = Object.entries(this.props.classes)
      if (text === '2018 - 2019' || text === '2018') {
        classes = classes.filter( clss => 
          !clss[1].createdAt
        )
      } else {
        classes = classes.filter( clss => 
          clss[1].createdAt
          &&
          clss[1].createdAt > from 
          &&
          clss[1].createdAt < to 
        )
      }
      classes.map( element => {
        if (!grades.includes(element[1].grade)) {
          grades.push(element[1].grade)
        }
      })
      return grades
    } else {
      return []
    }
  }

  getClasses = (field) => {
    let yearSelection = field === 'first' ? this.state.option_first_year : this.state.option_second_year
    if (this.props.classes && this.props.allYears && yearSelection !== 'Year') {
      let {from, to, text} = this.props.allYears.filter( year => year.text === yearSelection)[0]
      let classes = []
      Object.entries(this.props.classes).map( clss => {
        if (!classes.includes(clss[1].name)) {
          if (((text === '2018' ||text === '2018 - 2019') && !clss[1].createdAt) || (clss[1].createdAt > from && clss[1].createdAt < to  ))
          classes.push(clss[1].name)
        }
      })
      return classes
    } else {
      return []
    }
  }

  setOption = (field, value) => {
    let update;
    if (field === 'first') {
      update = {
        option_first: value
      }
      if (this.state.option_second === value && this.state.option_first_year === this.state.option_second_year) {
        update['option_second'] = null
      }
    } else {
      update = {
        option_second: value
      }
      if (this.state.option_first === value && this.state.option_first_year === this.state.option_second_year) {
        update['option_first'] = null
      }
    }
    this.setState(update)
  }

  getData = (field) => {
    const { allLogs, allStudents } = this.props
    const { option_first, option_second } = this.state
    if (allLogs && allStudents) {
      let logs = this.getLogsOfSchool(allLogs)
      let logs_first = option_first !== 'Class' && option_first !== 'Grade' ? this.filterLogs('first', logs, option_first) : []
      let logs_second = option_second !== 'Class' && option_second !== 'Grade' ? this.filterLogs('second', logs, option_second) : []
      let chart_data = this.buildChartData(logs_first, logs_second)
      console.log(logs_first.length, logs_second.length)
      //console.log('CHART DATA', chart_data)
      return chart_data
    } else {
      return []
    }
  }

  buildChartData = (logs_first, logs_second) => {
    let raw_skillslogged_first = [0,0,0,0,0,0,0,0,0,0,0,0,0]
    let raw_skillslogged_second = [0,0,0,0,0,0,0,0,0,0,0,0,0]
    let skillslogged = []
    logs_first = this.applyFilters(logs_first)
    logs_second = this.applyFilters(logs_second)

      //Find out which years and months are the logs from
      logs_first && logs_first.map( (log, i) => {
        let month = log[1].date.split("-")[1]
        if (month.charAt(0) == '0') {
          month = month.slice(1,2)
        }
        raw_skillslogged_first[month]++
      })

      logs_second && logs_second.map( (log, i) => {
        let month = log[1].date.split("-")[1]
        if (month.charAt(0) == '0') {
          month = month.slice(1,2)
        }
        raw_skillslogged_second[month]++
      })


      if (this.props.currentYear.year && this.props.currentYear.year.text.includes(' - ')) {
        
        skillslogged = [
          { name: 'Aug', first: raw_skillslogged_first[8], second: raw_skillslogged_second[8] },
          { name: 'Sept', first: raw_skillslogged_first[9], second: raw_skillslogged_second[9] },
          { name: 'Oct', first: raw_skillslogged_first[10], second: raw_skillslogged_second[10] },
          { name: 'Nov', first: raw_skillslogged_first[11], second: raw_skillslogged_second[11] },
          { name: 'Dec', first: raw_skillslogged_first[12], second: raw_skillslogged_second[12] },
          { name: 'Jan', first: raw_skillslogged_first[1], second: raw_skillslogged_second[1] },
          { name: 'Feb', first: raw_skillslogged_first[2], second: raw_skillslogged_second[2] },
          { name: 'Mar', first: raw_skillslogged_first[3], second: raw_skillslogged_second[3] },
          { name: 'Apr', first: raw_skillslogged_first[4], second: raw_skillslogged_second[4] },
          { name: 'May', first: raw_skillslogged_first[5], second: raw_skillslogged_second[5] },
          { name: 'Jun', first: raw_skillslogged_first[6], second: raw_skillslogged_second[6] },
          { name: 'Jul', first: raw_skillslogged_first[7], second: raw_skillslogged_second[7] }
        ]
      } else {
        skillslogged = [
          { name: 'Jan', first: raw_skillslogged_first[1], second: raw_skillslogged_second[1] },
          { name: 'Feb', first: raw_skillslogged_first[2], second: raw_skillslogged_second[2] },
          { name: 'Mar', first: raw_skillslogged_first[3], second: raw_skillslogged_second[3] },
          { name: 'Apr', first: raw_skillslogged_first[4], second: raw_skillslogged_second[4] },
          { name: 'May', first: raw_skillslogged_first[5], second: raw_skillslogged_second[5] },
          { name: 'Jun', first: raw_skillslogged_first[6], second: raw_skillslogged_second[6] },
          { name: 'Jul', first: raw_skillslogged_first[7], second: raw_skillslogged_second[7] },
          { name: 'Aug', first: raw_skillslogged_first[8], second: raw_skillslogged_second[8] },
          { name: 'Sept', first: raw_skillslogged_first[9], second: raw_skillslogged_second[9] },
          { name: 'Oct', first: raw_skillslogged_first[10], second: raw_skillslogged_second[10] },
          { name: 'Nov', first: raw_skillslogged_first[11], second: raw_skillslogged_second[11] },
          { name: 'Dec', first: raw_skillslogged_first[12], second: raw_skillslogged_second[12] },
        ]
      }
    return skillslogged
  }

  applyFilters = logs => {
    console.log('amountlogs' ,logs.length, this.state.selectedCategory)
    if (this.state.selectedCategory !== 'all') {
      logs = logs.filter( log =>
        log[1].atl_category.id == this.state.selectedCategory
      )
      if (this.state.selectedCluster !== 'all') {
        logs = logs.filter( log =>
          log[1].atl_cluster.id == this.state.selectedCluster
        )
      }
    }
    return logs
  }

  getLogsOfSchool = (logs) => {
    //Put school's student's id-s into an array
    let studentIds = [];
    this.props.allStudents.map(student => studentIds.push(student[0]))
    //Filter logs made  by students of this school
    logs = Object.entries(logs).filter(log =>
      studentIds.includes(log[1].user_id)
    )
    return logs
  }

  filterLogs = (field, logs, filter) => {
    const { compare } = this.state
    let yearSelection = field === 'first' ? this.state.option_first_year : this.state.option_second_year
    if (compare === 'classes') {
      let selectedClass = Object.entries(this.props.classes).filter( clss => clss[1].name === filter)[0][1]
      if (selectedClass) {
        logs = logs.filter(log =>
          log[1].subject.id == selectedClass.subject
          &&
          selectedClass.students
          &&
          Object.keys(selectedClass.students).includes(log[1].user_id)
        )
      }
    } else {
       // Find subjects and students in the grade
      let classes = this.props.classes ? Object.entries(this.props.classes) : []
      let studentsInGrade = []
      let subjectsInGrade = []
      classes.map(clss => {
        if (clss[1].grade == filter) {
          if (clss[1].students) {
            studentsInGrade = studentsInGrade.concat(Object.keys(clss[1].students))
          }
        subjectsInGrade.push(clss[1].subject)
        }
      })
      //Filter the logs made by these student
      logs = (studentsInGrade && subjectsInGrade) && logs.filter(log =>
        studentsInGrade.includes(log[1].user_id)
          &&
        subjectsInGrade.includes(log[1].subject.id)
      )
    }
    if (yearSelection !== 'Year' && logs && logs.length > 0) {
      logs = this.filterLogsByDate(yearSelection, logs)
    }
    return logs 
  }

  filterLogsByDate = (yearSelection, logs=[]) => {
    let { from, to, text } = this.props.allYears.filter(year => year.text === yearSelection)[0]
    console.log(from, to, logs)
    return logs.filter( log => {
      let timestamp = moment(log[1].date)
      if (timestamp >= from && timestamp <= to) {
        return true
      } else {
        return false
      }
    })
  }

  render() {

    let { data, t, categories, clusters, allYears } = this.props
    const { selectedCategory, selectedCluster } = this.state
    const translated = data && data.map( item => (
      {name: t(item.name) === 'Dec' ? 'Dec   ' : t(item.name), value: item.value}
    ))

    let option_values_first = this.state.compare === 'Compare' ? [] :
      this.state.compare === 'grades'
        ? this.getGrades('first')
        : this.getClasses('first')

    let option_values_second = this.state.compare === 'Compare' ? [] :
      this.state.compare === 'grades'
        ? this.getGrades('second')
        : this.getClasses('second')

    
    const tranlsatedData = this.getData().map( item => (
      {name: t(item.name) === 'Dec' ? 'Dec   ' : t(item.name),
       first: item.first,
       second: item.second
      }
    ))

    let first_biggest = 0
    let second_biggest = 0
    tranlsatedData.map( item => {
      if (item.first > first_biggest) {
        first_biggest = item.first
      }
      if (item.second > second_biggest) {
        second_biggest = item.second
      }
    })
    let firstAmount_isHigher = first_biggest >= second_biggest ? true : false

    clusters = Object.entries(clusters).filter( cluster =>
      cluster[1].category == selectedCategory
      &&
      cluster[1].readOnly == false
    )
    

    return (
      <div>
        <p style={styles.paragraph}>{t('Compare grades or classes')}</p>
        <div className="compare">
          <div>
            <Select 
              style={styles.button} 
              value={this.state.compare} 
              onChange={val => this.setState({compare: val, option_first: val === 'Grades' ? 'Grade' : 'Class', option_second: val === 'Grades' ? 'Grade' : 'Class' })}
            >
              <Option value="grades">{t('Grades')}</Option>
              <Option value="classes">{t('Classes')}</Option>
            </Select>
          </div>
          <div style={{width: 200, marginRight: 20}}>
            <Select id="first_option" disabled={this.state.compare === 'Compare'} style={styles.button} value={this.state.option_first_year} onChange={val => this.setState({option_first_year: val})}>
                {allYears && allYears.map( option => (
                  <Option value={option.text}>{option.text}</Option>
                ))}
            </Select>
            <Select id="first_option" disabled={this.state.compare === 'Compare' || this.state.option_first_year === 'Year'} style={styles.button} value={this.state.option_first} onChange={val => this.setOption('first', val)}>
              {option_values_first.map( option => (
                <Option value={option}>{option}</Option>
              ))}
            </Select>
          </div>
          <div style={{width: 200}}>
            <Select id="second_option" disabled={this.state.compare === 'Compare'} style={styles.button} value={this.state.option_second_year} onChange={val => this.setState({option_second_year: val})}>
                {allYears && allYears.map( option => (
                  <Option value={option.text}>{option.text}</Option>
                ))}
            </Select>
            <Select id="second_option" disabled={this.state.compare === 'Compare' || this.state.option_second_year === 'Year'} style={styles.button} value={this.state.option_second} onChange={val => this.setOption('second', val)}>
              {option_values_second.map( option => (
                <Option value={option}>{option}</Option>
              ))}
            </Select>
          </div>
        </div>
        <div style={{backgroundColor: '#d9d9d9', width: 'calc(100% - 40px)', height: 1, margin: '10px 40px 0px 40px'}} />
        <div style={{marginTop: 20, marginBottom: 30}} className="compare">
          <Select style={styles.button} value={selectedCategory} onChange={val => this.setState({selectedCategory: val, selectedCluster: 'all'})}>
            <Option value="all">{t('Category')}</Option>
            {categories && categories.map( cat => (
              <Option value={cat[0]}>{t(cat[1].name)}</Option>
            ))}
          </Select>
          <Select style={styles.button} value={selectedCluster} onChange={val => this.setState({selectedCluster: val})}>
            <Option value="all">{t('Cluster')}</Option>
            {clusters && clusters.map( clu => (
              <Option value={clu[0]}>{t(clu[1].name)}</Option>
            ))}
          </Select>
        </div>
        <div style={styles.container}>
          <ResponsiveContainer width="100%" height={350}>
            <AreaChart data={this.getData()}>
              {firstAmount_isHigher 
                ? <YAxis type="number" dataKey="first" allowDecimals={false} tickLine={false} axisLine={{stroke: '#8ca0b3'}} />
                : <YAxis type="number" dataKey="second" allowDecimals={false} tickLine={false} axisLine={{stroke: '#8ca0b3'}} />
              }
              {firstAmount_isHigher 
                ? <YAxis type="number" dataKey="second" allowDecimals={false} tickLine={false} axisLine={{stroke: '#8ca0b3'}} />
                : <YAxis type="number" dataKey="first" allowDecimals={false} tickLine={false} axisLine={{stroke: '#8ca0b3'}} />
              }
              <XAxis dataKey="name" tickLine={false} axisLine={{stroke: '#67B5E7'}} />
              <defs>
                <linearGradient id="gradient1" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#6EA237" stopOpacity={1}/>
                  <stop offset="95%" stopColor="#6EA237" stopOpacity={0.8}/>
                </linearGradient>
                <linearGradient id="gradient2" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#8ca0b3" stopOpacity={1}/>
                  <stop offset="95%" stopColor="#8ca0b324" stopOpacity={1}/>
                </linearGradient>
               </defs>
              <CartesianGrid strokeDasharray="3 3" />
              <Area
                dataKey="first"
                fill="url(#gradient1)"
                activeDot={{ stroke: '#6EA237' }}
                stroke={'#6EA237'}
              />
              <Area
                dataKey="second"
                fill="url(#gradient2)"
                activeDot={{ stroke: '#8ca0b3' }}
                stroke={'#8ca0b3'}
              />
              <Tooltip
                cursor={false}
                content={<CustomTooltip first_key={this.state.option_first} second_key={this.state.option_second} data={tranlsatedData} double={true} />}
                wrapperStyle={styles.wrapper}
                labelStyle={styles.label}
                itemStyle={styles.label}
                />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    )
  }
}

export default CompareTool;

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none'
  },

  label: {
    fontSize: '11px'
  },


  title: {
    fontSize: '16px',
    color: '#485465'
  },

  paragraph: {
    fontSize: '16px',
    marginBottom: '20px',
    marginLeft: '40px'
  },
  button: {
    borderRadius: '25px',
    width: '195px',
    marginRight: '20px',
  },

}



// WEBPACK FOOTER //
// ./src/components/CompareTool/index.jsx